
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/brand/2467",
      function () {
        return require("private-next-pages/shop/brand/2467.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/brand/2467"])
      });
    }
  